export const messages = {
  en: {
    itemReleaseDetail: {
      releaseDetails: 'Release Details',
      back: 'Back',
      applyCompany: 'Application Unit:',
      passType: 'Pass Type:',
      applicant: 'Applicant:',
      idCard: 'ID Card:',
      phone: 'Phone:',
      applyTime: 'Application Time:',
      status: 'Status:',
      licensePlate: 'License Plate:',
      passTime: 'Pass Time:',
      totalQuantity: 'Total Quantity:',
      releaseItems: 'Release Items',
      itemName: 'Item Name',
      quantity: 'Quantity',
      workflowProcess: 'Workflow Process',
      serialNumber: 'No.',
      department: 'Department',
      handler: 'Handler',
      processed: 'Processed',
      processing: 'Processing',
      timeConsumed: 'Time Consumed',
      comment: 'Comment',
      workOrderProcessing: 'Work Order Processing',
      action: 'Action',
      pleaseSelect: 'Please Select',
      agree: 'Agree',
      return: 'Return',
      returnToSubmitter: 'Return to Submitter',
      transfer: 'Transfer',
      workOrderDescription: 'Work Order Description',
      requiredDescription: 'Required, please fill in work order description',
      nextHandler: 'Next Handler',
      requiredNextHandler: 'Required, please select next handler',
      select: 'Select',
      submit: 'Submit',
      flowChart: 'Flow Chart',
      illegalOperation: 'Illegal operation',
      selectStatus: 'Please select status',
      fillDescription: 'Please fill in description',
      selectNextHandler: 'Please select next handler',
      submitSuccess: 'Submit successfully',
      submitFailed: 'Submit failed',
      administrator: 'Administrator'
    }
  },
  zh: {
    itemReleaseDetail: {
      releaseDetails: '放行详情',
      back: '返回',
      applyCompany: '申请单位：',
      passType: '通行类型：',
      applicant: '申请人：',
      idCard: '身份证：',
      phone: '手机号：',
      applyTime: '申请时间：',
      status: '状态：',
      licensePlate: '车牌号：',
      passTime: '通行时间：',
      totalQuantity: '物品总数量：',
      releaseItems: '放行物品',
      itemName: '物品名称',
      quantity: '数量',
      workflowProcess: '工单流转',
      serialNumber: '序号',
      department: '部门',
      handler: '处理人',
      processed: '处理完成',
      processing: '正在处理',
      timeConsumed: '耗时',
      comment: '意见',
      workOrderProcessing: '工单办理',
      action: '动作',
      pleaseSelect: '请选择',
      agree: '同意',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      transfer: '转单',
      workOrderDescription: '工单说明',
      requiredDescription: '必填，请填写工单说明',
      nextHandler: '下一处理人',
      requiredNextHandler: '必填，请选择下一处理人',
      select: '选择',
      submit: '提交',
      flowChart: '流程图',
      illegalOperation: '非法操作',
      selectStatus: '请选择状态',
      fillDescription: '请填写说明',
      selectNextHandler: '请选择下一节点处理人',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
administrator: '管理员'
    }
  },
  'zh-TW': {
    itemReleaseDetail: {
      releaseDetails: '放行詳情',
      back: '返回',
      applyCompany: '申請單位：',
      passType: '通行類型：',
      applicant: '申請人：',
      idCard: '身份證：',
      phone: '手機號：',
      applyTime: '申請時間：',
      status: '狀態：',
      licensePlate: '車牌號：',
      passTime: '通行時間：',
      totalQuantity: '物品總數量：',
      releaseItems: '放行物品',
      itemName: '物品名稱',
      quantity: '數量',
      workflowProcess: '工單流轉',
      serialNumber: '序號',
      department: '部門',
      handler: '處理人',
      processed: '處理完成',
      processing: '正在處理',
      timeConsumed: '耗時',
      comment: '意見',
      workOrderProcessing: '工單辦理',
      action: '動作',
      pleaseSelect: '請選擇',
      agree: '同意',
      return: '退回',
      returnToSubmitter: '退回至提交者',
      transfer: '轉單',
      workOrderDescription: '工單說明',
      requiredDescription: '必填，請填寫工單說明',
      nextHandler: '下一處理人',
      requiredNextHandler: '必填，請選擇下一處理人',
      select: '選擇',
      submit: '提交',
      flowChart: '流程圖',
      illegalOperation: '非法操作',
      selectStatus: '請選擇狀態',
      fillDescription: '請填寫說明',
      selectNextHandler: '請選擇下一節點處理人',
      submitSuccess: '提交成功',
      submitFailed: '提交失敗',
      administrator: '管理員'
    }
  }
}